export default "__VITE_PUBLIC_ASSET__6e2f8212__"